export function isChromeWindow(windowData) {
	if (!windowData) {
		return false;
	}

	return (
		(windowData.chrome_id && windowData.chrome_id.length > 0 && windowData.tab_id && windowData.tab_id.length > 0) ||
		(windowData.platform_type && windowData.platform_type === "chrome")
	);
}

export function getPlatformType(windowData) {
	if (!windowData) return null;

	// Returning the windows platform for companion mode atm.
	// This will be changed when the new companion mode live view modal is built.
	if (windowData.platform_type && windowData.platform_type === "companion") return "Windows";

	if (
		(windowData.chrome_id && windowData.chrome_id.length > 0 && windowData.tab_id && windowData.tab_id.length > 0) ||
		(windowData.platform_type && windowData.platform_type === "chrome")
	)
		return "Chromebook";

	if (windowData.platform_type && windowData.platform_type === "windows") return "Windows";

	if (windowData.platform_type && windowData.platform_type === "macos") return "Apple";

	return "";
}
